// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-scrollable {
  height: 100vh;
  overscroll-behavior: none !important;
}

.centered-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
}

.table-container {
  max-height: 400px;
  overflow-y: auto;
}

.table-container thead th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;
}

.recent-tests .section-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
}
.recent-tests .test-documents, .recent-tests .test-scenario {
  background: #fff;
  padding: 1rem;
  border-radius: 8px;
  border: gray 1px solid;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.recent-tests .section-header {
  margin-bottom: 1rem;
}
.recent-tests .section-header h5 {
  margin: 0;
  font-size: 1.2rem;
}
.recent-tests .search-input, .recent-tests .search-bar {
  width: 200px;
  border-radius: 4px;
  padding: 0.5rem;
}
.recent-tests table th, .recent-tests table td {
  text-align: left;
  padding: 0.75rem;
}

.create-new-btn:hover {
  background-color: transparent !important;
  color: inherit !important;
  border-color: inherit !important;
}

test-table-container {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 20px;
  border: 1px solid #eaeaea;
  background-color: #fff;
  height: 100%;
}

.test-table-title {
  font-weight: 600;
  margin-bottom: 20px;
}

.test-table-scrollable {
  max-height: 555px;
  overflow-y: auto;
}

.test-table-header {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
}

.test-table-no-data {
  text-align: center;
}

.details-modal-scrollable {
  max-height: 400px;
  overflow-y: auto;
}

.details-modal-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;
}

.details-modal-wide-column {
  min-width: 300px;
}

.details-modal-pre {
  white-space: pre-wrap;
  margin: 0;
}

.sidebar {
  width: 230px;
  min-height: 100vh;
  background-color: #1f1f2e;
}

.sidebar .nav-link {
  color: #ccc;
  font-weight: 500;
}

.sidebar .nav-link.active,
.sidebar .nav-link:hover {
  background-color: #343a40;
  color: #fff;
  border-radius: 8px;
}

.proceed-btn {
  background-color: #0d99ff;
  border: none;
  padding: 6px 20px;
  border-radius: 6px;
  font-size: 14px;
}

.create-new-btn {
  font-size: 14px;
  padding: 6px 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Dashboard/Dashboard.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,oCAAA;AACJ;;AACA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAEJ;;AAAE;EACE,iBAAA;EACA,gBAAA;AAGJ;;AAAE;EACE,gBAAA;EACA,MAAA;EACA,iBAAA;EACA,UAAA;AAGJ;;AAAI;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;AAGN;AAAI;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,wCAAA;AAEN;AACI;EACE,mBAAA;AACN;AAAM;EACE,SAAA;EACA,iBAAA;AAER;AAEI;EACE,YAAA;EACA,kBAAA;EACA,eAAA;AAAN;AAIM;EACE,gBAAA;EACA,gBAAA;AAFR;;AAME;EACE,wCAAA;EACA,yBAAA;EACA,gCAAA;AAHJ;;AAKE;EACE,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AAFJ;;AAKE;EACE,gBAAA;EACA,mBAAA;AAFJ;;AAKE;EACE,iBAAA;EACA,gBAAA;AAFJ;;AAKE;EACE,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,UAAA;AAFJ;;AAKE;EACE,kBAAA;AAFJ;;AAKE;EACE,iBAAA;EACA,gBAAA;AAFJ;;AAKE;EACE,gBAAA;EACA,MAAA;EACA,iBAAA;EACA,UAAA;AAFJ;;AAKE;EACE,gBAAA;AAFJ;;AAKE;EACE,qBAAA;EACA,SAAA;AAFJ;;AAIE;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;AADF;;AAIA;;EAEE,yBAAA;EACA,WAAA;EACA,kBAAA;AADF;;AAGA;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,iBAAA;AAAF","sourcesContent":[".dashboard-scrollable{\n    height: 100vh;\n    overscroll-behavior: none !important;\n}\n.centered-message {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    text-align: center;\n  }\n  .table-container {\n    max-height: 400px;\n    overflow-y: auto;\n  }\n  \n  .table-container thead th {\n    position: sticky;\n    top: 0;\n    background: white;\n    z-index: 2;\n  }\n  .recent-tests {\n    .section-title {\n      font-size: 1.5rem;\n      font-weight: bold;\n      margin-bottom: 1rem;\n    }\n  \n    .test-documents, .test-scenario {\n      background: #fff;\n      padding: 1rem;\n      border-radius: 8px;\n      border: gray 1px solid;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    }\n  \n    .section-header {\n      margin-bottom: 1rem;\n      h5 {\n        margin: 0;\n        font-size: 1.2rem;\n      }\n    }\n  \n    .search-input, .search-bar {\n      width: 200px;\n      border-radius: 4px;\n      padding: 0.5rem;\n    }\n  \n    table {\n      th, td {\n        text-align: left;\n        padding: 0.75rem;\n      }\n    }\n  }\n  .create-new-btn:hover {\n    background-color: transparent !important;\n    color: inherit !important; \n    border-color: inherit !important;\n  }\n  test-table-container {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    border-radius: 10px;\n    padding: 20px;\n    border: 1px solid #eaeaea;\n    background-color: #fff;\n    height: 100%;\n  }\n  \n  .test-table-title {\n    font-weight: 600;\n    margin-bottom: 20px;\n  }\n  \n  .test-table-scrollable {\n    max-height: 555px;\n    overflow-y: auto;\n  }\n  \n  .test-table-header {\n    position: sticky;\n    top: 0;\n    background: #fff;\n    z-index: 2;\n  }\n  \n  .test-table-no-data {\n    text-align: center;\n  }\n  \n  .details-modal-scrollable {\n    max-height: 400px;\n    overflow-y: auto;\n  }\n  \n  .details-modal-header {\n    position: sticky;\n    top: 0;\n    background: white;\n    z-index: 2;\n  }\n  \n  .details-modal-wide-column {\n    min-width: 300px;\n  }\n  \n  .details-modal-pre {\n    white-space: pre-wrap;\n    margin: 0;\n  }\n  .sidebar {\n  width: 230px;\n  min-height: 100vh;\n  background-color: #1f1f2e;\n}\n\n.sidebar .nav-link {\n  color: #ccc;\n  font-weight: 500;\n}\n\n.sidebar .nav-link.active,\n.sidebar .nav-link:hover {\n  background-color: #343a40;\n  color: #fff;\n  border-radius: 8px;\n}\n.proceed-btn {\n  background-color: #0d99ff;\n  border: none;\n  padding: 6px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.create-new-btn {\n  font-size: 14px;\n  padding: 6px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
